let xhr = require('client/xhr');

let delegate = require('client/delegate');
let Spinner = require('client/spinner');
const config = require('config');
const { Captcha } = require('client/captcha');
const t = require('engine/i18n/t');
const LANG = require('config').lang;

let loginForm = require('../templates/login-form.pug');
let registerForm = require('../templates/register-form.pug');
let forgotForm = require('../templates/forgot-form.pug');

let clientRender = require('client/clientRender');

let notification = require('client/notification');

t.i18n.add('auth', require('../locales/' + LANG + '.yml'));

/**
 * Options:
 *   - callback: function to be called after successful login (by default - go to successRedirect)
 *   - message: form message to be shown when the login form appears ("Log in to leave the comment")
 *   - successRedirect: the page to redirect (current page by default)
 *       - after immediate login
 *       - after registration for "confirm email" link
 */
class AuthForm {

  constructor(options) {
    this.options = options;

    if (!options.successRedirect) {
      // options.successRedirect = window.STATUS_CODE < 300 ? window.location.href : '/';
      options.successRedirect = window.location.href;
    }

    this.options.providers = config.providers;
  }

  render() {
    this.elem = document.createElement('div');
    this.elem.innerHTML = clientRender(loginForm, this.options);

    if (this.options.message) {
      this.showFormMessage(this.options.message);
    }

    if (this.options.email) {
      this.elem.querySelector('[name="email"]').value = this.options.email;
      this.elem.querySelector('[name="email"]').removeAttribute('autofocus');
      this.elem.querySelector('[name="password"]').setAttribute('autofocus', '');
    }

    this.initEventHandlers();
  }

  getElem() {
    if (!this.elem) this.render();
    return this.elem;
  }

  successRedirect() {
    if (window.location.href == this.options.successRedirect) {
      window.location.reload();
    } else {
      window.location.href = this.options.successRedirect;
    }
  }

  clearFormMessages() {
    /*
     remove error for this notation:
     span.text-input.text-input_invalid.login-form__input
     input.text-input__control#password(type="password", name="password")
     span.text-inpuxt__err Пароли не совпадают
     */
    [].forEach.call(this.elem.querySelectorAll('.text-input_invalid'), function(elem) {
      elem.classList.remove('text-input_invalid');
    });

    [].forEach.call(this.elem.querySelectorAll('.text-input__err'), function(elem) {
      elem.remove();
    });

    // clear form-wide notification
    this.elem.querySelector('[data-notification]').innerHTML = '';
  }

  request(options) {
    let request = xhr(options);

    request.addEventListener('loadstart', function() {
      let onEnd = this.startRequestIndication();
      request.addEventListener('loadend', onEnd);
    }.bind(this));

    return request;
  }

  startRequestIndication() {
    this.elem.classList.add('modal-overlay_light');

    let submitButton = this.elem.querySelector('[type="submit"]');

    let spinner;
    if (submitButton) {
       spinner = new Spinner({
        elem:      submitButton,
        size:      'small',
        class:     '',
        elemClass: 'button_loading'
      });
      spinner.start();
    }

    return () => {
      this.elem.classList.remove('modal-overlay_light');
      if (spinner) spinner.stop();
    };

  }

  initEventHandlers() {

    this.delegate('[data-switch="register-form"]', 'click', function(e) {
      e.preventDefault();
      this.elem.innerHTML = clientRender(registerForm, this.options);
      this.registerCaptcha = new Captcha(this.elem.querySelector('form'));
      autofocus(this.elem);
    });

    this.delegate('[data-switch="login-form"]', 'click', function(e) {
      e.preventDefault();
      this.elem.innerHTML = clientRender(loginForm, this.options);
      autofocus(this.elem);
    });

    this.delegate('[data-switch="forgot-form"]', 'click', function(e) {
      e.preventDefault();

      // move currently entered email into forgotForm
      let oldEmailInput = this.elem.querySelector('[type="email"]');
      this.elem.innerHTML = clientRender(forgotForm, this.options);
      // recaptcha.render(this.elem.querySelector('.login-form__recaptcha'));
      let newEmailInput = this.elem.querySelector('[type="email"]');
      newEmailInput.value = oldEmailInput.value;
      autofocus(this.elem);
    });


    this.delegate('[data-form="login"]', 'submit', function(event) {
      event.preventDefault();
      this.submitLoginForm(event.target);
    });


    this.delegate('[data-form="register"]', 'submit', function(event) {
      event.preventDefault();
      this.submitRegisterForm(event.target);
    });

    this.delegate('[data-form="forgot"]', 'submit', function(event) {
      event.preventDefault();
      this.submitForgotForm(event.target);
    });

    this.delegate('[data-provider]', 'click', function(event) {
      event.preventDefault();
      this.openAuthPopup('/auth/login/' + event.delegateTarget.dataset.provider);
    });

    this.delegate('[data-action-verify-email]', 'click', function(event) {
      event.preventDefault();

      let payload = new FormData();
      let email = event.delegateTarget.dataset.actionVerifyEmail;
      payload.append('email', email);

      let request = this.request({
        method: 'POST',
        url:    '/auth/reverify',
        body:   payload
      });

      let self = this;
      request.addEventListener('success', function(event) {

        if (this.status == 200) {
          self.showFormMessage({
            html: t('auth.auth_form.letter_resend', {email}),
            type: 'success'
          });
        } else {
          self.showFormMessage({type: 'error', html: event.result});
        }

      });

    });

    this.delegate('[data-action-accept-agreements]', 'change', function(event) {
      let isAcceptAgreements = event.delegateTarget.checked;
      let registerButton = this.elem.querySelector('[type="submit"]');
      registerButton.disabled = !isAcceptAgreements;
    });
  }

  async submitRegisterForm(form) {
    this.clearFormMessages();

    let hasErrors = false;
    if (!form.elements.email.value) {
      hasErrors = true;
      this.showInputError(form.elements.email, t('auth.auth_form.enter_email'));
    }

    if (!form.elements.displayName.value) {
      hasErrors = true;
      this.showInputError(form.elements.displayName, t('auth.auth_form.enter_displayname'));
    }

    if (!form.elements.password.value) {
      hasErrors = true;
      this.showInputError(form.elements.password, t('auth.auth_form.enter_password'));
    }

    if (hasErrors) return;

    await this.registerCaptcha.validateForm(form);

    let payload = new FormData(form);
    payload.append('successRedirect', this.options.successRedirect);

    let request = this.request({
      method:         'POST',
      url:            '/auth/register',
      normalStatuses: [201, 400, 403],
      body:           payload
    });

    let self = this;
    request.addEventListener('success', function(event) {

      if (this.status == 201) {
        self.elem.innerHTML = clientRender(loginForm, self.options);
        self.showFormMessage({
          html: t('auth.auth_form.letter_sent', {
            email: form.elements.email.value,
            notifyEmail: 'notify@javascript.ru'
          }),
          type: 'success'
        });
        return;
      }

      if (this.status == 400) {
        for (let field in event.result.errors) {
          self.showInputError(form.elements[field], event.result.errors[field]);
        }
        return;
      }

      if (this.status == 403) {
        new notification.Error(event.result.message);
        return;
      }

      self.showFormMessage({html: t('auth.auth_form.unknown_error'), type:'error'});
    });

  }


  submitForgotForm(form) {

    /*
    if (!form.elements['captcha-response'].value) {
      new notification.Error("Подтвердите, пожалуйста, что вы не робот (капча).");
      return;
    }
    */

    this.clearFormMessages();

    let hasErrors = false;
    if (!form.elements.email.value) {
      hasErrors = true;
      this.showInputError(form.elements.email, t('auth.auth_form.enter_email'));
    }

    if (hasErrors) return;

    let payload = new FormData(form);
    payload.append('successRedirect', this.options.successRedirect);

    let request = this.request({
      method:         'POST',
      url:            '/auth/forgot',
      normalStatuses: [200, 404, 403],
      body:           payload
    });

    let self = this;
    request.addEventListener('success', function(event) {

      if (this.status == 200) {
        self.elem.innerHTML = clientRender(loginForm, self.options);
        self.showFormMessage({html: event.result, type: 'success'});
      } else if (this.status == 404) {
        self.showFormMessage({html: event.result, type: 'error'});
      } else if (this.status == 403) {
        self.showFormMessage({html: event.result.message || t('auth.auth_form.forbidden'), type: 'error'});
      }
    });

  }

  showInputError(input, error) {
    input.parentNode.classList.add('text-input_invalid');
    let errorSpan = document.createElement('span');
    errorSpan.className = 'text-input__err';
    errorSpan.innerHTML = error;
    input.parentNode.appendChild(errorSpan);
  }

  showFormMessage(message) {
    let html = message.html;
    if (html.indexOf('<p>') !== 0) {
      html = '<p>' + html + '</p>';
    }

    let type = message.type;
    if (['info', 'error', 'warning', 'success'].indexOf(type) == -1) {
      throw new Error('Unsupported type: ' + type);
    }

    let container = document.createElement('div');
    container.className = 'login-form__' + type;
    container.innerHTML = html;

    this.elem.querySelector('[data-notification]').innerHTML = '';
    this.elem.querySelector('[data-notification]').appendChild(container);
  }

  submitLoginForm(form) {

    this.clearFormMessages();

    let hasErrors = false;
    if (!form.elements.email.value) {
      hasErrors = true;
      this.showInputError(form.elements.email, t('auth.auth_form.enter_email'));
    }

    if (!form.elements.password.value) {
      hasErrors = true;
      this.showInputError(form.elements.password, t('auth.auth_form.enter_password'));
    }

    if (hasErrors) return;

    let request = xhr({
      method:           'POST',
      url:              '/auth/login/local',
      noDocumentEvents: true, // we handle all events/errors in this code
      normalStatuses:   [200, 401],
      body:             new FormData(form)
    });

    let onEnd = this.startRequestIndication();

    request.addEventListener('success', (event) => {

      if (request.status == 401) {
        onEnd();
        this.onAuthFailure(event.result.message);
        return;
      }

      // don't stop progress indication if login successful && we're making redirect
      if (!this.options.callback) {
        this.onAuthSuccess(event.result.user);
      } else {
        onEnd();
        this.onAuthSuccess(event.result.user);
      }
    });

    request.addEventListener('fail', (event) => {
      onEnd();
      this.onAuthFailure(event.reason);
    });

  }

  openAuthPopup(url) {
    if (this.authPopup && !this.authPopup.closed) {
      this.authPopup.close(); // close old popup if any
    }
    let width = 800, height = 600;
    let top = (window.outerHeight - height) / 2;
    let left = (window.outerWidth - width) / 2;
    window.authForm = this;
    this.authPopup = window.open(url, 'authForm', 'width=' + width + ',height=' + height + ',scrollbars=0,top=' + top + ',left=' + left);
  }

  /*
   все обработчики авторизации (включая Facebook из popup-а и локальный)
   в итоге триггерят один из этих каллбэков
   */
  onAuthSuccess(user) {
    window.currentUser = user;
    if (this.options.callback) {
      this.options.callback();
    } else {
      this.successRedirect();
    }
  }

  onAuthFailure(errorMessage) {
    this.showFormMessage({html: errorMessage || t('auth.auth_form.auth_reject'), type: 'error'});
  }
}

function autofocus(elem) {
  let autofocus = elem.querySelector('[autofocus]');
  if (autofocus) autofocus.focus();
}

delegate.delegateMixin(AuthForm.prototype);

module.exports = AuthForm;
